import React from "react";
import styled from "styled-components";
import "./forgelock.css";

export const theme = {
  colors: {
    // background: "#000000",
    text: "#FFFFFF",
    textSecondary: "#808080",
    primary: "#404040",
  },
  breakpoints: {
    mobile: "320px",
    tablet: "768px",
    desktop: "1280px",
  },
};

const ForgeLockPage = () => {
  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <Container>
        <ContainerSpacer />
        <ContentSection>
          <Title
            onClick={() =>
              window.open("https://forgelock-site.danials.space/", "_blank")
            }
          >
            ForgeLock
          </Title>
          <Description>
            ForgeLock is an open-source password generator that helps you create
            strong, memorable, and secure passwords.
          </Description>
          <Feature>
            <a
              href="https://forgelock.danials.space"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              🚀 Try ForgeLock
            </a>
          </Feature>
          <FeatureList>
            <Feature>✦ Generate secure and complex passwords</Feature>
            <Feature>✦ Easy to use interface</Feature>
            <Feature>✦ Secure and offline generation</Feature>
          </FeatureList>
          <Feature>
            <a
              href="https://github.com/danial2026/forgelock_app"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              ✨ Open Source on GitHub
            </a>
          </Feature>
        </ContentSection>
        <ImageSection>
          <div className="phone-mockup">
            <iframe
              src="home-screen-forgelock.html"
              title="Web App"
              className="webapp-iframe"
            ></iframe>
          </div>
        </ImageSection>
      </Container>
      {/* <div style={{ margin: "8rem 0" }} /> 
      <Container>
        <ContentSection>
          <Title
            onClick={() =>
              window.open("https://topbeat.danials.space/", "_blank")
            }
          >
            Topbeat
          </Title>
          <Description>Discover your top song and artist</Description>
          <Feature>
            <a
              href="https://topbeat.danials.space/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              🚀 Try Topbeat
            </a>
          </Feature>
          <FeatureList>
            <Feature>✦ Connect your Spotify account</Feature>
            <Feature>✦ See your most-played track</Feature>
            <Feature>✦ Share your music taste</Feature>
          </FeatureList>
        </ContentSection>
        <ImageSection>
          <div className="phone-mockup">
            <iframe
              src="home-screen-topbeat.html"
              title="Web App"
              className="webapp-iframe"
            ></iframe>
          </div>
        </ImageSection>
      </Container> */}
    </div>
  );
};

const ContainerSpacer = styled.div`
  flex: 1.5;
  @media (max-width: 1280px) {
    display: none;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 90%;
  background-color: ${theme.colors.background};
  padding: 4rem 2rem;
  justify-content: space-between;
  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const ContentSection = styled.div`
  flex: 2.5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;

  @media (max-width: 1280px) {
    padding: 0;
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  color: ${theme.colors.text};
  // margin-bottom: 1rem;

  @media (max-width: 1280px) {
    font-size: 3rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: ${theme.colors.textSecondary};
  max-width: 37.5rem;
  line-height: 1.6;
`;
const ImageSection = styled.div`
  flex: 4.5;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1280px) {
    display: none;
  }
`;

const Phone = styled.img`
  position: absolute;
  height: 90%;
  width: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
  filter: drop-shadow(0 0 20px rgba(0, 0, 0, 0.3));

  &:hover {
    transform: scale(1.05);
    z-index: 3;
  }
`;

const TagLine = styled.div`
  font-size: 1.5rem;
  color: ${theme.colors.text};
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: start;
`;

const FeatureList = styled.div`
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  color: ${theme.colors.text};
  display: flex;
  flex-direction: column;
`;

const Feature = styled.div`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

export default ForgeLockPage;
